angular.module('bookingApp')
    .directive('skAgentLogin', function($location){
        return {
            scope: {
                'appPath': '=?',
                'sellerEntityId': '=?',
                'sellerEntityName': '=?',
                'validationType': '=?',
                'sessionId': '=?',
                'skLoader': '=?',
                'disableFooter': '=',
                'agentLoginTemplateText': '=?',
                'displayAgentLoginLink': '=?'
            },
            link: function($scope, elem, attrs, ctrl){},
            controller: function($scope, $http, $sce){
                $scope.userIsValidated = false;
                $scope.sellerEntityCode = '';
                $scope.username = '';
                $scope.showLoginButton = true;
                $scope.showAgentLoginForm = false;
                $scope.agentLoginErrors = [];
                $scope.hideCompleteModal = false;

                $scope.$location = $location;
                $scope.previouslyLoaded = false;
                $scope.$watch('$location.path()', function(locationPath){
                    if($scope.previouslyLoaded){
                        $scope.hideCompleteModal = true;
                    } else {
                        if(locationPath === '/' || locationPath === '/#'){
                            $scope.hideCompleteModal = false;
                        } else {
                            $scope.hideCompleteModal = true;
                            $scope.previouslyLoaded = true;
                        }
                    }


                });
                $scope.to_trusted = function(html_code){
                    return $sce.trustAsHtml(html_code);
                };


                // only ask for seller entity if it hasn't been passed in.
                $scope.askForAgentId = false;
                if(!$scope.sellerEntityId){
                    $scope.askForAgentId = true;
                    $scope.showLoginButton = true;
                } else {
                    $scope.showLoginButton = false;
                }
                $scope.showLoginLink = $scope.askForAgentId;

                if($scope.sellerEntityId && $scope.validationType !== 'none'){
                    $scope.showAgentLoginForm = true;
                }

                if($scope.validationType === 'user'){
                    $scope.userName = '';
                }

                $scope.cancelShowLoginForm = function(){
                    $scope.showAgentLoginForm = false;
                    $scope.showLoginButton = true;
                    $scope.disableFooter = false;
                };

                $scope.toggleAgentLoginForm = function(){
                    $scope.showAgentLoginForm = !$scope.showAgentLoginForm;
                    $scope.showLoginButton = !$scope.showLoginButton;
                    if($scope.showAgentLoginForm){
                        $scope.showLoginButton = false;
                        $scope.disableFooter = true;
                    } else {
                        $scope.showLoginButton = true;
                        $scope.disableFooter = false;
                    }
                };

                // this is the overlying function called by the form. This decides which other calls to make
                $scope.runCheck = function(){
                    $scope.skLoader = true;
                    // if it is a seller entity check...
                    if(!$scope.validationType){
                        $scope.getSellerEntityValidationType();
                    } else {
                        if($scope.validationType === 'user'){ // user login validation
                            $scope.checkLogin();
                        } else { // code based validation
                            $scope.checkSellerCode();
                        }
                    }
                };

                $scope.clearErrors = function(){
                    $scope.agentLoginErrors = [];
                };

                // check with server if user requires login code - if the user doesn't require a login code the server should process the form completely no need for second ajax call
                $scope.getSellerEntityValidationType = function(){
                    var userAgentForm = {
                        agentCode: $scope.sellerEntityId
                    };
                    $scope.clearErrors();
                    $http.post('/front-booking/validate-user-agent/', {
                        userAgentForm: userAgentForm,
                        sid: $scope.sessionId,
                        device: 'mobile',
                        format: 'json'
                    }).success(function(data){
                        if(data.validationRequired){
                            if(data.success) {
                                $scope.askForAgentId = false;
                                // set validationType...
                                if (data.isUserAgent) {
                                    $scope.validationType = 'user';
                                } else {
                                    $scope.validationType = 'code';
                                }
                            } else {
                                // display the errors to the user. the seller entity is not set.
                                if(data.errors.hasOwnProperty('serverLevel')){
                                    $.each(data.errors.serverLevel, function(index, errorMsg){
                                        $scope.agentLoginErrors.push(errorMsg);
                                    })
                                } else {
                                    $.each(data.errors.formLevel.elementLevel, function(index, errorMsg){
                                        $scope.agentLoginErrors.push(errorMsg);
                                    })
                                }
                            }
                        } else {
                            if(data.success) {
                                $scope.validationType = 'none';
                                $scope.showAgentLoginForm = false;
                                // set the agent name...
                                $scope.sellerEntityName = data.agentDetails.name;
                                $scope.disableFooter = false;
                            }
                        }
                        $scope.skLoader = false;
                    }).error(function(data, status, headers, config){
                        $scope.skLoader = false;
                    });
                };

                $scope.checkSellerCode = function(){
                    var userAgentForm = {
                        agentCode: $scope.sellerEntityId,
                        userCode: $scope.sellerEntityCode
                    };
                    $scope.clearErrors();
                    $http.post('/front-booking/validate-user-agent/', {
                        userAgentForm: userAgentForm,
                        sid: $scope.sessionId,
                        device: 'mobile',
                        format: 'json'
                    }).success(function(data){
                        // do validation on this
                        if(data.success){
                            // hide the login form
                            $scope.showAgentLoginForm = false;
                            $scope.userIsValidated = true;
                            // set the agent name...
                            $scope.sellerEntityName = data.agentDetails.name;
                            $scope.disableFooter = false;
                        } else {
                            // show the errors to the user - the code is incorrect
                            if(data.errors.hasOwnProperty('serverLevel')){
                                $.each(data.errors.serverLevel, function(index, errorMsg){
                                    $scope.agentLoginErrors.push(errorMsg);
                                })
                            } else {
                                $.each(data.errors.formLevel.elementLevel, function(index, errorMsg){
                                    $scope.agentLoginErrors.push(errorMsg);
                                })
                            }
                        }
                        $scope.skLoader = false;
                    }).error(function(data, status, headers, config){
                        $scope.skLoader = false;
                    });
                };

                // check login
                $scope.checkLogin = function(){
                    var userAgentForm = {
                        agentCode: $scope.sellerEntityId,
                        username: $scope.username,
                        userCode: $scope.sellerEntityCode
                    };
                    $scope.clearErrors();
                    $http.post('/front-booking/validate-user-agent/', {
                        userAgentForm: userAgentForm,
                        sid: $scope.sessionId,
                        device: 'mobile',
                        format: 'json'
                    }).success(function(data){
                        // do validation on this
                        if(data.success){
                            $scope.showAgentLoginForm = false;
                            $scope.userIsValidated = true;
                            // set the user name...
                            $scope.sellerEntityName = '';
                            $scope.userName = data.userAgentDetails.firstName + ' '  + data.userAgentDetails.lastName;
                            $scope.disableFooter = false;
                        } else {
                            // show the errors to the user - the username / password is incorrect
                            if(data.errors.hasOwnProperty('serverLevel')){
                                $.each(data.errors.serverLevel, function(index, errorMsg){
                                    $scope.agentLoginErrors.push(errorMsg);
                                })
                            } else {
                                $.each(data.errors.formLevel.elementLevel, function(index, errorMsg){
                                    $scope.agentLoginErrors.push(errorMsg);
                                })
                            }
                        }
                        $scope.skLoader = false;
                    }).error(function(data, status, headers, config){
                        $scope.skLoader = false;
                    });
                };
            },
            template: '<div class="sk-agent-login container-fluid">' +
                '<div class="login-link text-center row">' +
                    '<div class="container-fluid">' +
                        '<a ng-hide="hideCompleteModal" class="btn btn-primary col-xs-12" ' +
                            'href="" ' +
                            'ng-click="toggleAgentLoginForm()" ' +
                            'ng-if="showLoginButton && displayAgentLoginLink">Agent Login <span class="glyphicon glyphicon-log-in"></span></a>' +
                        '<div ng-if="validationType === \'none\' || userIsValidated">' +
                            'Logged in as ' +
                            '<span ng-if="sellerEntityName"><span ng-bind="sellerEntityName"></span></span>' +
                            '<a ng-if="userName" href=""><span ng-bind="userName"></span></a>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="agent-login-container" ng-show="!userIsValidated && showAgentLoginForm && !hideCompleteModal">' +
                    '<header class="text-center">Agent Login</header>' +
                    '<div class="template-agent-login-text col-xs-12" ng-if="agentLoginTemplateText" ng-bind-html="to_trusted(agentLoginTemplateText)"></div>' +
                    '<div class="agent-login-errors alert alert-danger" role="alert" ng-show="agentLoginErrors.length > 0">' +
                        '<span ng-repeat="error in agentLoginErrors" ng-bind-html="error"></span>' +
                    '</div>' +
                    '<div class="agent-login-form">'+
                        '<div class="sk-input-group col-xs-12 inactive" sk-text ng-class="" ng-show="askForAgentId">' +
                            '<label for="">Agent Id</label>' +
                            '<input type="text" name="username" id="username" ng-model="sellerEntityId">' +
                        '</div>' +
                
                        '<div class="sk-input-group col-xs-12 inactive" sk-text ng-class="" ng-show="validationType === \'code\'">' +
                            '<label for="">Agent Code</label>' +
                            '<input type="text" name="logincode" id="logincode" ng-model="sellerEntityCode">' +
                        '</div>' +

                        '<div class="sk-input-group col-xs-12 inactive" sk-text ng-class="" ng-show="validationType === \'user\'">' +
                            '<label>Username</label>' +
                            '<input type="text" ng-model="username">' +
                        '</div>' +
                        '<div class="sk-input-group col-xs-12 inactive" sk-password ng-show="validationType === \'user\'">' +
                            '<label>Password</label>' +
                            '<input type="password" ng-model="sellerEntityCode">' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="container-fluid">' +
                                '<button class="btn btn-primary col-xs-6" ng-click="cancelShowLoginForm()">Cancel <span class="glyphicon glyphicon-remove"></span></button>' +
                                '<button class="btn btn-primary col-xs-6" ng-click="runCheck()">Continue <span class="glyphicon glyphicon-chevron-right"></span></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>'
        }
    });
